var _g, _g2, _g3, _g4, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMini = function SvgMini(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_835",
    "data-name": "Group 835",
    width: 72,
    height: 34.231,
    viewBox: "0 0 72 34.231",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    transform: "translate(0.02 22.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M603.544,325.867h.805c-.017-.2-.031-.4-.031-.606a7.143,7.143,0,0,1,1.94-4.892H597.67A5.9,5.9,0,0,0,603.544,325.867Z",
    transform: "translate(-597.67 -320.369)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M667.9,315.761l-12.111-.9a4.372,4.372,0,0,1-2.924-1.426l-4.416-4.861a23.276,23.276,0,0,0-17.2-7.611H602.521a4.05,4.05,0,0,0-4.02,3.727l-.534,11.605h2.165a.413.413,0,0,1,0,.827h-2.2l-.125,2.718h2.23a.413.413,0,1,1,0,.825h-2.268l-.112,2.457h9.524a7.128,7.128,0,0,1,8.648,0H652.7a7.13,7.13,0,0,1,8.649,0h8.306V318.79h-4.584a.413.413,0,0,1,0-.825h4.584v-.313A1.906,1.906,0,0,0,667.9,315.761Zm-42.351-12.124h3.363V314.3l-2.416.009h0a.95.95,0,0,1-.947-.947Zm4.674,10.657V303.638h1.259a19.753,19.753,0,0,1,14.927,6.811l2.782,3.2a.346.346,0,0,1-.259.573Zm-8.684-.919H601.159a.413.413,0,1,1,0-.825h20.376a.413.413,0,0,1,0,.825Zm0-2.829H601.256a.413.413,0,0,1,0-.827h20.279a.413.413,0,0,1,0,.827Zm0-2.83H601.355a.413.413,0,1,1,0-.825h20.181a.413.413,0,0,1,0,.825Zm0-2.83H601.452a.413.413,0,0,1,0-.827h20.084a.413.413,0,0,1,0,.827Zm7.587,13.51h-2.141a.413.413,0,1,1,0-.825h2.141a.413.413,0,0,1,0,.825Z",
    transform: "translate(-597.653 -300.959)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(19.089 22.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M615.711,325.261c0,.2-.013.406-.031.606H646.9c-.017-.2-.031-.4-.031-.606a7.148,7.148,0,0,1,1.94-4.892H613.773A7.147,7.147,0,0,1,615.711,325.261Z",
    transform: "translate(-613.773 -320.369)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832",
    transform: "translate(64.61 22.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M654.154,325.261c0,.2-.014.406-.031.606h2.263a3.22,3.22,0,0,0,3.217-3.215v-2.283h-7.389A7.148,7.148,0,0,1,654.154,325.261Z",
    transform: "translate(-652.214 -320.369)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(53.015 21.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M642.525,326.509c.023.139.043.277.075.412a6.338,6.338,0,0,0,12.355,0c.031-.135.051-.274.073-.412s.028-.276.043-.414c.019-.2.06-.4.06-.606a6.313,6.313,0,0,0-2.351-4.892,5.886,5.886,0,0,0-.525-.413,6.439,6.439,0,0,0-.759-.413,6.5,6.5,0,0,0-6.2.413,6.074,6.074,0,0,0-.526.413,6.316,6.316,0,0,0-2.349,4.892,5.985,5.985,0,0,0,.062.606C642.5,326.233,642.5,326.373,642.525,326.509Zm6.251-5.146a4.13,4.13,0,0,1,4.126,4.126,3.928,3.928,0,0,1-.062.606,3.983,3.983,0,0,1-.081.414c-.037.14-.079.277-.129.412a4.105,4.105,0,0,1-7.709,0,4.174,4.174,0,0,1-.128-.412,4.018,4.018,0,0,1-.082-.414,4.077,4.077,0,0,1-.062-.606A4.131,4.131,0,0,1,648.776,321.363Z",
    transform: "translate(-642.422 -319.134)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834",
    transform: "translate(7.495 21.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M614.34,320.6a6.066,6.066,0,0,0-.526-.413,6.224,6.224,0,0,0-6.2-.413,6.439,6.439,0,0,0-.759.413,6.039,6.039,0,0,0-.525.413,6.316,6.316,0,0,0-2.349,4.892,6.02,6.02,0,0,0,.062.606c.013.139.019.278.041.414s.043.277.073.412a6.337,6.337,0,0,0,12.353,0c.032-.135.052-.274.075-.412s.029-.276.042-.414a6.02,6.02,0,0,0,.062-.606A6.316,6.316,0,0,0,614.34,320.6Zm.059,5.5a4.018,4.018,0,0,1-.082.414,4.111,4.111,0,0,1-7.965,0,4,4,0,0,1-.081-.414,3.921,3.921,0,0,1-.062-.606,4.125,4.125,0,1,1,8.25,0A4.077,4.077,0,0,1,614.4,326.095Z",
    transform: "translate(-603.982 -319.134)",
    fill: "rgba(6,1,108,0.25)"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMini, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mini.45ab67c9.svg";
export { ForwardRef as ReactComponent };